<script setup lang="ts">
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import AlertBox from '@/components/Elements/Alerts/AlertBox.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { handleNext } from '../tutorialSteps'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const route = useRoute()
const router = useRouter()

const handleNextStep = async () => {
  await handleNext('tutorial_military_intro')
}

const isOnCommandSection = computed(() => {
  return route.path.startsWith('/command/ships')
})

const goToCommand = () => {
  router.push('/command/ships')
}

</script>

<template>
  <TutorialFrame
    video-url="https://cdn.ferion.com/videos/advisors/temperate/military.webm"
  >
    <template #text>
      <p class="pb-2">
        {{ t('tutorial.military.intro.greetings') }}
      </p>
      <p class="pb-2">
        {{ t('tutorial.military.intro.established') }}
      </p>
      <p class="pb-2">
        {{ t('tutorial.military.intro.commandCenter') }}
      </p>
      <p class="pb-2">
        {{ t('tutorial.military.intro.strongMilitary') }}
      </p>
    </template>

    <template #alerts>
      <AlertBox type="info" class="hidden md:flex">
        {{ t('tutorial.military.intro.clickCommandDesktop') }}
      </AlertBox>
      <AlertBox type="info" class="md:hidden">
        {{ t('tutorial.military.intro.clickCommandMobile') }}
      </AlertBox>
    </template>

    <template #buttons>
      <ActionButton v-if="!isOnCommandSection" @click="goToCommand" class="mr-2">
        {{ t('tutorial.military.intro.goToCommand') }}
      </ActionButton>
      <ActionButton @click="handleNextStep">
        {{ t('tutorial.military.intro.letsGo') }}
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss"></style>